function _parseDataLocal(dataStr) {
    const [ano, mes, dia] = dataStr.split('-').map(Number)
    return new Date(ano, mes - 1, dia) // mês é 0-based
}


function dataAtual(diasAdd = 0){
    const d = new Date();
    if (diasAdd){
        d.setHours(0,0,0,0);
        d.setDate(d.getDate() + diasAdd);
    }
    return d.toISOString().split('T')[0];
}


function decimalFromString(value) {
    if (!value) return 0;
    return parseFloat(value.toString().replace(/\./g, '').replace(',', '.')) || 0;
}


function decimalFromTimeString(horaString) {
    if (!horaString || horaString.length != 5) return 0;
    const [horas, minutos] = horaString.split(":").map(Number);
    return horas + minutos / 60;
}

function formatDate(date) {
    return date.toLocaleDateString('pt-BR');
    // const day = String(date.getDate()).padStart(2, '0')
    // const month = String(date.getMonth() + 1).padStart(2, '0')
    // const year = date.getFullYear()
    // return `${day}/${month}/${year}`
}


function formatDateFromJson(dataStr){
    if (!dataStr) return '';
    const datePart = dataStr.includes('T') ? dataStr.split('T')[0] : dataStr;
    const [year, month, day] = datePart.split('-');
    return `${day}/${month}/${year}`;
}


function formatDateTimeFromJson(dataStr) {
    if (!dataStr) return '';
    const [datePart, timePart] = dataStr.includes('T') ? dataStr.split('T') : [dataStr, ''];
    const [year, month, day] = datePart.split('-');
    const [hour, minute] = timePart.split(':');
    return `${day}/${month}/${year} ${hour}:${minute}`;
}


function formatDecimal(value, decimals = 2) {
    if (value === null || value === undefined || value === '') {
        return '';
    }

    if (typeof value === 'number') {
        return value.toLocaleString('pt-BR', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        });
    }

    let str = value.toString().trim();

    // se possui vírgula assume padrão BR
    if (str.includes(',')) {
        str = str.replace(/\./g, '');
        str = str.replace(',', '.');
    }

    const num = Number(str);

    if (isNaN(num)) {
        return '';
    }

    return num.toLocaleString('pt-BR', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
}


function formatFileSize(bytes) {
    if (bytes < 1024) return `${bytes} B`;
    else if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    else return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}


function formatMoney(value){
    return numberFromValue(value || 0).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });
}


function formatInteger(value) {
    if (value===0) return '0';
    if (!value) return '';
    return parseInt(value).toLocaleString('pt-BR');
}


function formatTimeFromDecimal(value){
    if (value === 0){return '00:00';}
    let hours = Math.floor(value);
    let minutes = Math.round((value - hours) * 60);
    if (minutes === 60) {
        hours++;
        minutes = 0;
    }
    const hoursStr = String(hours).padStart(2, '0');
    const minutesStr = String(minutes).padStart(2, '0');
    return `${hoursStr}:${minutesStr}`;
}


function formatTimeFromJson(value){
    if (!value) return '';
    return String(value).substring(0,5);
}


function getId(obj) {
    // 14-07-25: FUNÇÃO QUE RETORNA "ID" DO OBJETO PARA PADRONIZAÇÃO NOS FORMULÁRIOS
    return obj?.id ?? 0;
}

function getIntervaloMes(mes, ano) {
    const mesAjustado = mes - 1; // porque o JS começa os meses em 0
    const primeiroDia = new Date(ano, mesAjustado, 1);
    const ultimoDia = new Date(ano, mesAjustado + 1, 0);
  
    const formatarData = (data) => data.toISOString().split('T')[0];
  
    return {
        datainicial: formatarData(primeiroDia),
        datafinal: formatarData(ultimoDia)
    }
}


function integerFromString(value) {
    if (!value) return 0;
    return parseInt(value.toString().replace(/\./g, '')) || 0;
}


function numberFromValue(value){
    if (value === null || value === undefined || value === '') {
        return 0;
    }

    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : 0;
    }

    const normalized = String(value)
        .trim()
        .replace(/\./g, '')
        .replace(',', '.');

    const number = Number(normalized);

    return Number.isFinite(number) ? number : 0;
}


function parseDataInput(dataStr) {
    if (!dataStr) return '';
    if (dataStr.includes('-')) {
        return dataStr.split('T')[0];
    }
    if (dataStr.includes('/')) {
        const [dia, mes, ano] = dataStr.split('/');
        return `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
    }
    return '';
}


function parseDataLocal(dataStr) {
    if (!dataStr || typeof dataStr !== 'string') return null;
    const dataLimpa = dataStr.trim().split(' ')[0].split('T')[0];
    let dia, mes, ano;

    if (dataLimpa.includes('-')) {
        [ano, mes, dia] = dataLimpa.split('-').map(Number);
    } else if (dataLimpa.includes('/')) {
        [dia, mes, ano] = dataLimpa.split('/').map(Number);
    } else {
        return null;
    }

    if (!dia || !mes || !ano) return null;
    return new Date(ano, mes - 1, dia);
}


function strDataAtual(){
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    return `${day}/${month}/${year}`;
}


function strDataAtualYMD(){
    const hoje = new Date();
    hoje.setMinutes(hoje.getMinutes() - hoje.getTimezoneOffset());
    return hoje.toISOString().slice(0, 10);
}


function strDataHoraAtual(){
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
}


function strDataIsoFromString(s) {
  if (!s) return '';

  // Se já está em ISO, devolve direto
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;

  // Se está em BR, inverte para ISO
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) {
    const [dia, mes, ano] = s.split('/');
    return `${ano}-${mes}-${dia}`;
  }

  console.warn(`strDataIsoFromString: formato não reconhecido →`, s);
  return '';
}


function strHoraAtual(){
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
}


function validarCNPJ(cnpj) {
    if (!cnpj) throw new Error('CNPJ não informado')

    const cleaned = cnpj.replace(/\D/g, '')
    if (cleaned.length !== 14) throw new Error('CNPJ deve conter 14 dígitos')

    if (/^(\d)\1{13}$/.test(cleaned)) throw new Error('CNPJ inválido')

    const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
    const pesos2 = [6, ...pesos1]

    const calcularDigito = (base, pesos) => {
        const soma = base.reduce((acc, num, i) => acc + num * pesos[i], 0)
        const resto = soma % 11
        return resto < 2 ? 0 : 11 - resto
    }

    const numeros = cleaned.split('').map(Number)
    const base = numeros.slice(0, 12)
    const digito1 = calcularDigito(base, pesos1)
    const digito2 = calcularDigito([...base, digito1], pesos2)

    if (digito1 !== numeros[12] || digito2 !== numeros[13]) {
        throw new Error('CNPJ inválido')
    }
}

function validarCNPJouCPF(dados){
    if (!dados) throw new Error('CPF/CNPJ não informado');
    const cleaned = dados.replace(/\D/g, '');
    (cleaned.length > 11) ? validarCNPJ(dados) : validarCPF(dados);
}


function validarCPF(cpf) {
    if (!cpf) throw new Error('CPF não informado')

    const cleaned = cpf.replace(/\D/g, '')
    if (cleaned.length !== 11) throw new Error('CPF deve conter 11 dígitos')

    if (/^(\d)\1{10}$/.test(cleaned)) throw new Error('CPF inválido')

    let soma = 0
    for (let i = 0; i < 9; i++) {
        soma += parseInt(cleaned.charAt(i)) * (10 - i)
    }
    let resto = (soma * 10) % 11
    if (resto === 10 || resto === 11) resto = 0
    if (resto !== parseInt(cleaned.charAt(9))) throw new Error('CPF inválido')

    soma = 0
    for (let i = 0; i < 10; i++) {
        soma += parseInt(cleaned.charAt(i)) * (11 - i)
    }
    resto = (soma * 10) % 11
    if (resto === 10 || resto === 11) resto = 0
    if (resto !== parseInt(cleaned.charAt(10))) throw new Error('CPF inválido')
}


function validarData(dataStr, diasMinimos = 0){
    if (!dataStr) throw new Error('Data não informada')
        
    const dataInformada = _parseDataLocal(dataStr)
    dataInformada.setHours(0, 0, 0, 0)
    
    const dataLimite = new Date()
    dataLimite.setHours(0, 0, 0, 0)
    dataLimite.setDate(dataLimite.getDate() + diasMinimos)
  
    if (dataInformada < dataLimite) {
      throw new Error(`A data deve ser igual ou superior a ${formatDate(dataLimite)}`)
    }
}


function validarIntervaloDatas(startDate, endDate, obrigatorio = true) {
    if (!startDate || !endDate) {
        if (obrigatorio){throw new Error('Necessário informar ambas as datas.')} else {return}
    }

    const dataInicio = new Date(startDate);
    const dataFim = new Date(endDate);

    if (isNaN(dataInicio.getTime()) || isNaN(dataFim.getTime())) {
        throw new Error('Datas inválidas. Verifique o formato das datas.')
    }

    if (dataFim < dataInicio) {
        throw new Error('A data final deve ser maior ou igual à data inicial.')
    }
}


// Export único organizado
export const Funcoes = {
    dataAtual,
    decimalFromString,
    decimalFromTimeString,
    formatDate,
    formatDateFromJson,
    formatDateTimeFromJson,
    formatDecimal,
    formatFileSize,
    formatInteger,
    formatMoney,
    formatTimeFromDecimal,
    formatTimeFromJson,
    getId,
    getIntervaloMes,
    integerFromString,
    numberFromValue,
    parseDataInput,
    parseDataLocal,
    strDataAtual,
    strDataAtualYMD,
    strDataHoraAtual,
    strDataIsoFromString,
    strHoraAtual,
    validarData,
    validarIntervaloDatas,
    validarCNPJ,
    validarCNPJouCPF,
    validarCPF,
}